<template>
  <fvSelect class="form-control select text-right fv-size-md"
            v-model="valData"
            :options="options"
            :placeholder="placeholder"
  >
  </fvSelect>
</template>

<script>
  export default {
    props: {
      placeholder: {
        type: String
      },
      value: {
        type: String,
      },
      required: [Boolean, Function],
    },
    data() {
      return {
        options: this.$store.state.main.itemTypes,
      }
    },
    computed: {
      valData: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    methods: {

    }
  }
</script>

<style lang="scss">
.defaultIcon{
  &.female{
    color: #ff879d !important;
  }
  &.male{
    color: blue !important;
  }

}

</style>
